export const root = "r19k1lf9";
export const link = "l1ee76y4";
export const hasPopOut = "hzy9bxv";
export const active = "a1a4jndp";
export const blip = "b3agbow";
export const betaTag = "bz11rpw";
export const newTag = "n1h6gdai";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");